import { render, staticRenderFns } from "./COVID-19.vue?vue&type=template&id=60c9a255&scoped=true&"
import script from "./COVID-19.vue?vue&type=script&lang=js&"
export * from "./COVID-19.vue?vue&type=script&lang=js&"
import style0 from "./COVID-19.vue?vue&type=style&index=0&id=60c9a255&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c9a255",
  null
  
)

export default component.exports